<b3-drawer
  [open]="open"
  size="md"
  overlay
  (b3-close)="close()"
  (b3-back)="close()">
  <b3-drawer-header
    heading="Detalhes do Crédito de Carbono"
    aria-level="2"
    show-back
    close-aria-label="Fechar"
    back-aria-label="Voltar">
  </b3-drawer-header>

  <b3-drawer-body>
    <div class="emission-details-drawer" *ngIf="!isLoading && emission; else drawerState">
      <div class="emission-details-drawer__steps">
        <div class="emission-details-drawer__steps-header">
          <span class="emission-details-drawer__section-title">Etapas</span>
          <b3-button
            type="button"
            variant="ghost"
            tone="default"
            size="sm"
            (b3-click)="exportToCSV()">
            <b3-icon name="download"></b3-icon>
            Exportar
          </b3-button>
        </div>

        <b3-tag
          *ngFor="let step of stepTags; trackBy: trackByStepLabel"
          class="emission-details-drawer__step-tag"
          size="sm"
          variant="filled"
          [icon]="step.icon"
          [tone]="step.tone"
          [label]="step.label">
        </b3-tag>
      </div>

      <section class="emission-details-drawer__section">
        <h2 class="emission-details-drawer__section-title">Projeto gerador de créditos</h2>

        <div class="emission-details-drawer__grid emission-details-drawer__grid--2">
          <div class="emission-details-drawer__field">
            <span class="emission-details-drawer__label">Nome do projeto</span>
            <span class="emission-details-drawer__value">{{ projectName }}</span>
          </div>
          <div class="emission-details-drawer__field">
            <span class="emission-details-drawer__label">Número de emissão</span>
            <span class="emission-details-drawer__value">{{ emission.emissionNumber || '-' }}</span>
          </div>
        </div>

        <div class="emission-details-drawer__grid emission-details-drawer__grid--2">
          <div class="emission-details-drawer__field">
            <span class="emission-details-drawer__label">Quantidade total (tCO2)</span>
            <span class="emission-details-drawer__value">{{ emission.emissionQuantity }}</span>
          </div>
          <div class="emission-details-drawer__field">
            <span class="emission-details-drawer__label">Status</span>
            <span class="emission-details-drawer__value">{{ emission.status || '-' }}</span>
          </div>
        </div>

        <div class="emission-details-drawer__field emission-details-drawer__field--full">
          <span class="emission-details-drawer__label">Data de Registro</span>
          <span class="emission-details-drawer__value">{{ emission.insertDate || '-' }}</span>
        </div>

        <div class="emission-details-drawer__field emission-details-drawer__field--full">
          <span class="emission-details-drawer__label">Serial Range</span>
          <span class="emission-details-drawer__value">{{ emission.serialCode || '-' }}</span>
        </div>

        <div *ngIf="showRejectionReason" class="emission-details-drawer__field emission-details-drawer__field--full">
          <span class="emission-details-drawer__label emission-details-drawer__label--danger">
            <b3-icon name="do_not_disturb_on" size="sm" tone="danger"></b3-icon>
            Motivo
          </span>
          <span class="emission-details-drawer__value emission-details-drawer__value--danger">
            {{ emission.reasonRejection || '-' }}
          </span>
        </div>
      </section>

      <hr class="emission-details-drawer__divider" aria-hidden="true">

      <section class="emission-details-drawer__section">
        <h2 class="emission-details-drawer__section-title">Responsável</h2>

        <div class="emission-details-drawer__grid emission-details-drawer__grid--2">
          <div class="emission-details-drawer__field">
            <span class="emission-details-drawer__label">Conta detentor</span>
            <span class="emission-details-drawer__value">{{ emission.holderCode || '-' }}</span>
          </div>
          <div class="emission-details-drawer__field">
            <span class="emission-details-drawer__label">CNPJ desenvolvedor</span>
            <span class="emission-details-drawer__value">{{ emission.cpfCnpjCode || '-' }}</span>
          </div>
        </div>
      </section>

      <hr class="emission-details-drawer__divider" aria-hidden="true">

      <section class="emission-details-drawer__section">
        <h2 class="emission-details-drawer__section-title">Período de geração de crédito</h2>

        <div class="emission-details-drawer__grid emission-details-drawer__grid--2">
          <div class="emission-details-drawer__field">
            <span class="emission-details-drawer__label">Data inicial</span>
            <span class="emission-details-drawer__value">{{ emission.startDate || '-' }}</span>
          </div>
          <div class="emission-details-drawer__field">
            <span class="emission-details-drawer__label">Data final</span>
            <span class="emission-details-drawer__value">{{ emission.endDate || '-' }}</span>
          </div>
        </div>
      </section>

      <hr class="emission-details-drawer__divider" aria-hidden="true">

      <section class="emission-details-drawer__section">
        <h2 class="emission-details-drawer__section-title">Safra</h2>

        <div class="emission-details-drawer__harvest-table">
          <div class="emission-details-drawer__harvest-row emission-details-drawer__harvest-row--header">
            <span class="emission-details-drawer__label">Ano Da Safra</span>
            <span class="emission-details-drawer__label">Créditos Gerados Nessa Safra</span>
            <span class="emission-details-drawer__label">Desenvolvedor</span>
          </div>
          <div
            *ngFor="let harvest of harvests"
            class="emission-details-drawer__harvest-row">
            <span class="emission-details-drawer__value">{{ harvest.harvestYear }}</span>
            <span class="emission-details-drawer__value">{{ harvest.quantity }}</span>
            <span class="emission-details-drawer__value">{{ harvest.developerName || '-' }}</span>
          </div>
          <div *ngIf="!harvests.length" class="emission-details-drawer__harvest-row">
            <span class="emission-details-drawer__value">-</span>
            <span class="emission-details-drawer__value">-</span>
            <span class="emission-details-drawer__value">-</span>
          </div>
        </div>
      </section>

      <hr class="emission-details-drawer__divider" aria-hidden="true">

      <section class="emission-details-drawer__section">
        <h2 class="emission-details-drawer__section-title">Relatório de Monitoramento (RM)</h2>

        <div class="emission-details-drawer__field emission-details-drawer__field--full">
          <span class="emission-details-drawer__label">Link do relatório</span>
          <a
            *ngIf="rmLink && rmLink !== '-'; else emptyRmLink"
            class="emission-details-drawer__link"
            [href]="rmLink"
            target="_blank"
            rel="noopener noreferrer">
            {{ rmLink }}
            <b3-icon name="open_in_new" size="sm"></b3-icon>
          </a>
          <ng-template #emptyRmLink>
            <span class="emission-details-drawer__value">-</span>
          </ng-template>
        </div>

        <div class="emission-details-drawer__field emission-details-drawer__field--full">
          <span class="emission-details-drawer__label">Descrição do Relatório</span>
          <p class="emission-details-drawer__value emission-details-drawer__value--description">
            {{ emission.details || '-' }}
          </p>
        </div>
      </section>

      <footer class="emission-details-drawer__footer">
        <ng-container [ngSwitch]="footerMode">
          <ng-container *ngSwitchCase="'audit'">
            <div class="emission-details-drawer__footer-actions">
              <b3-button
                class="emission-details-drawer__footer-btn"
                type="button"
                variant="filled"
                tone="danger"
                (b3-click)="openRejectAnalysisModal()">
                <b3-icon name="do_not_disturb_on" size="md" tone="on-brand"></b3-icon>
                Rejeitar
              </b3-button>
              <b3-button
                class="emission-details-drawer__footer-btn"
                type="button"
                variant="filled"
                tone="default"
                (b3-click)="openApproveConfirmation()">
                <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
                Aprovar
              </b3-button>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'developer'">
            <b3-button
              class="emission-details-drawer__footer-btn emission-details-drawer__footer-btn--single"
              type="button"
              variant="filled"
              tone="default"
              (b3-click)="confirmDeveloperApproveReport()">
              <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
              Confirmar recebimento do RM
            </b3-button>
          </ng-container>

          <ng-container *ngSwitchCase="'clone'">
            <b3-button
              class="emission-details-drawer__footer-btn emission-details-drawer__footer-btn--single"
              type="button"
              variant="filled"
              tone="default"
              (b3-click)="openCloneConfirmation()">
              <b3-icon name="content_copy" size="md" tone="on-brand"></b3-icon>
              Clonar Emissão
            </b3-button>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <b3-button
              class="emission-details-drawer__footer-btn emission-details-drawer__footer-btn--single"
              type="button"
              variant="filled"
              tone="default"
              (b3-click)="close()">
              <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
              Entendi
            </b3-button>
          </ng-container>
        </ng-container>
      </footer>
    </div>

    <ng-template #drawerState>
      <p *ngIf="isLoading" class="emission-details-drawer__loading">Carregando detalhes da emissão...</p>
      <div *ngIf="!isLoading && loadError" class="emission-details-drawer__error">
        <p class="emission-details-drawer__loading">{{ loadError }}</p>
        <b3-button type="button" variant="outlined" tone="default" (b3-click)="close()">
          Fechar
        </b3-button>
      </div>
    </ng-template>
  </b3-drawer-body>
</b3-drawer>

<app-emission-reject-analysis-modal
  *ngIf="showRejectModal"
  [open]="showRejectModal"
  [projectName]="projectName"
  (openChange)="onRejectModalDismiss()"
  (confirmed)="onRejectConfirmed($event)">
</app-emission-reject-analysis-modal>

<b3-modal
  *ngIf="showApproveModal"
  [open]="showApproveModal"
  overlay
  size="md"
  (b3-close)="onApproveModalDismiss()">
  <b3-modal-header
    heading="Aprovar emissão"
    aria-level="2"
    icon="info"
    icon-tone="info"
    close-aria-label="Fechar">
  </b3-modal-header>
  <b3-modal-body>
    <p class="emission-details-drawer__modal-text">Deseja aprovar esta emissão?</p>
  </b3-modal-body>
  <b3-modal-footer>
    <div class="emission-details-drawer__modal-footer">
      <b3-button type="button" variant="outlined" tone="default" (b3-click)="onApproveModalDismiss()">
        Cancelar
      </b3-button>
      <b3-button type="button" variant="filled" tone="default" (b3-click)="confirmApproveEmission()">
        Confirmar
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>

<b3-modal
  *ngIf="showCloneModal"
  [open]="showCloneModal"
  overlay
  size="md"
  (b3-close)="onCloneModalDismiss()">
  <b3-modal-header
    heading="Clonar Emissão"
    aria-level="2"
    icon="info"
    icon-tone="info"
    close-aria-label="Fechar">
  </b3-modal-header>
  <b3-modal-body>
    <p class="emission-details-drawer__modal-text">Deseja clonar esta Emissão?</p>
  </b3-modal-body>
  <b3-modal-footer>
    <div class="emission-details-drawer__modal-footer">
      <b3-button type="button" variant="outlined" tone="default" (b3-click)="onCloneModalDismiss()">
        Cancelar
      </b3-button>
      <b3-button type="button" variant="filled" tone="default" (b3-click)="confirmCloneEmission()">
        Confirmar
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
